import script from "./ServicesSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServicesSection.vue?vue&type=script&lang=ts&setup=true"

import "./ServicesSection.vue?vue&type=style&index=0&id=3dc97986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc97986"]])

export default __exports__